import { useRoute } from '@react-navigation/native';

const APP_TYPE_CREATOR_MODEL = 'CREATOR_MODEL';

/**
 * app_type=CREATOR_MODEL 딥링크 진입 시 찜폴더 선택 UI를 스킵할지 결정.
 * NavigationContainer 내부에서만 사용 가능.
 */
export const useSkipFolderSelection = (): boolean => {
  try {
    const route = useRoute();
    const appType = (route.params as Record<string, unknown> | undefined)
      ?.app_type;
    const value = Array.isArray(appType) ? appType[0] : appType;
    return value === APP_TYPE_CREATOR_MODEL;
  } catch {
    return false;
  }
};
